import React, { useEffect, useState } from 'react';
import Swiper from 'react-id-swiper';
import styled from 'styled-components';
import 'swiper/css/swiper.css';

import { Flex } from '../atom/Layout';
import { FractionSwiperContainer } from './Swiper';

export const ThumbnailView = ({ imageList = [{ src: '', alt: '' }] }) => {
  const [swiper, updateSwiper] = useState(null);
  const [swiperThumbs, updateSwiperThumbs] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const videoIndices = imageList.reduce((arr, item, index) => {
    item.src.hasOwnProperty('video') && arr.push(index);
    return arr;
  }, []);

  const params = {
    shouldSwiperUpdate: true,
    spaceBetween: 30,
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    getSwiper: updateSwiper,
    loop: imageList.length > 4,
    lazy: true,
  };

  const thumbnailSwiperParams = {
    spaceBetween: 14,
    slidesPerView: 'auto',
    touchRatio: 0.2,
    slideToClickedSlide: true,
    getSwiper: updateSwiperThumbs,
    loop: imageList.length > 4,
    centeredSlides: imageList.length < 5,
  };

  useEffect(() => {
    const videos = document.querySelectorAll('video');

    videos.forEach((video) => {
      video.muted = true;
      video.autoPlay = true;
    });
  }, []);

  useEffect(() => {
    const updateIndex = () => setCurrentIndex(swiper.realIndex);

    if (swiper && swiperThumbs) {
      swiper.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiper;

      swiper.on('slideChange', updateIndex);
    }

    return () => {
      if (swiper && swiperThumbs) swiper.off('slideChange', updateIndex);
    };
  }, [swiper, swiperThumbs]);

  return (
    <Flex column>
      <GallerySwiper currentIndex={currentIndex} videoIndices={videoIndices}>
        <Swiper {...params}>
          {imageList.map((img, idx) =>
            img.src.video ? (
              <video
                key={idx}
                data-src={img.src.video}
                autoPlay
                muted
                playsInline
                controls
                poster={img.src.poster}
                className="swiper-lazy"
              />
            ) : (
              <img key={idx} src={img.src} alt={img.alt} />
            ),
          )}
        </Swiper>
      </GallerySwiper>
      <ThumbnailSwiper>
        <Swiper {...thumbnailSwiperParams}>
          {imageList.map((img, thumnailidx) => (
            <img
              key={thumnailidx}
              src={img.src.video ? img.src.thumbnail : img.src}
              alt={img.alt}
            />
          ))}
        </Swiper>
      </ThumbnailSwiper>
    </Flex>
  );
};

const GallerySwiper = styled(FractionSwiperContainer)`
  width: 100%;
  .swiper-container {
    height: 17.5rem;
  }

  video {
    background: black;
  }
`;

const ThumbnailSwiper = styled.div`
  width: 100%;
  padding: 0.625rem 1.25rem;

  .swiper-slide-active {
    border: 0.1875rem solid rgb(255, 100, 82);
  }

  img {
    width: 3.5rem;
    height: 3.5rem;
    object-fit: cover;
    box-sizing: border-box;
  }
`;
